export default [
    {
        path: '/app/dealer/apply.html',
        component: (resolve) => require(['@/view/app/dealer/apply/index.vue'],resolve),
    },
    {
        path: '/app/dealer/user.html',
        component: (resolve) => require(['@/view/app/dealer/user/index.vue'],resolve),
    },
    {
        path: '/app/dealer/goods.html',
        component: (resolve) => require(['@/view/app/dealer/goods/index.vue'],resolve),
    },
    {
        path: '/app/dealer/goods/create.html',
        component: (resolve) => require(['@/view/app/dealer/goods/create.vue'],resolve),
    },
    {
        path: '/app/dealer/order.html',
        component: (resolve) => require(['@/view/app/dealer/order/index.vue'],resolve),
    },
    {
        path: '/app/dealer/withdraw.html',
        component: (resolve) => require(['@/view/app/dealer/withdraw/index.vue'],resolve),
    },
    {
        path: '/app/dealer/level.html',
        component: (resolve) => require(['@/view/app/dealer/level/index.vue'],resolve),
    },
    {
        path: '/app/dealer/setting.html',
        component: (resolve) => require(['@/view/app/dealer/setting/index.vue'],resolve),
    },
]
